import React, { useEffect, useState } from 'react'
import { DI, DIProps } from '../../../Core'
import { Badge, BlockStack, Button, Card, EmptyState, Icon, InlineStack, Pagination, SkeletonBodyText, Text, TextField, Thumbnail } from '@shopify/polaris'
import { ChevronDownMinor, ChevronRightMinor, SearchMinor } from '@shopify/polaris-icons'
import { Table } from 'antd';
import NoResultsFound from '../../../Asests/Images/NoResultsFound.png';
import { columns, variantsColumns } from './Utils/Constants';
import Noimage from '../../../../public/files/noImage.png';
import Skeleton from './skeleton/Skeleton';
import { useDebounce } from '../useDebounce';
import { useTranslation } from 'react-i18next';
interface variantProps {
    rowData: any
    key: any
    index: number
    t: any
}

const NewProductImport = (props: DIProps) => {
    const { t } = useTranslation();
    const countPerPage: number = 10;
    const [data, setData] = useState([]);
    const [totalPages, setTotalPages] = useState<number>(1);
    const [activePage, setActivePage] = useState<number>(1);
    const [row, setRows] = useState([]);
    const [loader, setLoader] = useState<boolean>(true);
    const [inputValue, setInputValue] = useState<string>('');

    useEffect(() => {
        getPendingBatchImportProducts();
    }, [activePage])




    const debounceValue = useDebounce(inputValue, 500)
    useEffect(() => {
        getPendingBatchImportProducts(debounceValue)
    }, [debounceValue])

    const getPendingBatchImportProducts = (searchVal?: string) => {
        let pages: number = 0;
        setLoader(true);
        let obj: any = {
            'user_id': props.redux.user_id,
            'shop_id': props.di.globalState.get('source_id'),  //shopify shop_id
            'activePage': activePage,
            'count': countPerPage
        };
        if (searchVal && searchVal !== '') {
            obj['filter'] = searchVal;
        }
        props.di.GET('shopifyhome/request/getPendingBatchImportProducts', obj)
            .then((response: any) => {
                if (response?.success) {
                    pages = Math.ceil(response?.data?.count / countPerPage)
                    setData(response?.data?.rows)
                    setTotalPages(pages);
                }
                else props.error(t(response?.message))
                setLoader(false);
            })
    }

    const renderBadge = (type: string) => {
        switch (type) {
            case "listings_add":
                return <Badge size='small' tone='info'>{t("New Product")}</Badge>
            case "listings_update":
                return <Badge size='small'>{t("New Variant")}</Badge>
        }
    }

    useEffect(() => {
        let temp: any = [];
        data?.length > 0 &&
            data?.forEach((dataRow: any, idx: number) => {
                temp?.push({
                    key: dataRow?.container_id,
                    product: (
                        <InlineStack gap="300" blockAlign='center' wrap={false}>
                            <Thumbnail source={dataRow?.image || Noimage} size='medium' alt='produt_image' />
                            <Text as='p' breakWord fontWeight='medium'>{dataRow?.title || ""}</Text>
                        </InlineStack>
                    ),
                    badge: renderBadge(dataRow?.type),
                    unique_id: dataRow?.container_id,
                    variants: dataRow?.variants?.length || 0,
                    additionalDataFromEditProd: dataRow?.variants || []
                })
            })
        setRows(temp)
    }, [data])




    const onPrev = () => {
        setLoader(true)
        setActivePage(prev => prev - 1);
    }

    const onNext = () => {
        setLoader(true)
        setActivePage(prev => prev + 1);
    }
    const handleChange = (value: any) => {
        if (value && value.keyCode === 13) {
            getPendingBatchImportProducts(inputValue)
        }
    }

    return (
        <Card roundedAbove='sm'>
            <BlockStack gap="200">
                <InlineStack gap="200">
                    <div className='Custom-Stack-Item--fill'>
                        <span onKeyDown={(value: any) => handleChange(value)}>


                            <TextField
                                label=''
                                labelHidden
                                value={inputValue}
                                onChange={(val: string, id) => setInputValue(val)}
                                placeholder={t('Search your product here')}
                                autoComplete='off'
                                align='left'
                                clearButton


                                onClearButtonClick={() => {
                                    setInputValue('')
                                    getPendingBatchImportProducts()
                                }}
                                prefix={<Icon source={SearchMinor} tone="base" />}
                            />
                        </span>
                    </div>
                    <Button onClick={() => getPendingBatchImportProducts(inputValue)}>{t("Search")}</Button>
                </InlineStack>
                {
                    loader ?
                        <Skeleton />
                        :
                        data?.length > 0 ?
                            <Table
                                columns={columns(t)}
                                dataSource={[...row]}
                                loading={loader}
                                size="middle"
                                pagination={false}
                                expandable={{
                                    expandedRowRender: (record, key, index) => (<RenderVariants t={t} rowData={record} key={key} index={index} />),
                                    rowExpandable: (record) => record?.['variants'] > 0,
                                    expandIcon: ({ expanded, onExpand, record }) => {
                                        if (record?.['variants'] > 0) {
                                            return expanded ?
                                                <span style={{ cursor: 'pointer' }} onClick={(e: any) => onExpand(record, e)}>
                                                    <div><Icon source={ChevronDownMinor} tone="base" /></div>
                                                </span>
                                                :
                                                <span style={{ cursor: 'pointer' }} onClick={(e: any) => onExpand(record, e)}>
                                                    <div><Icon source={ChevronRightMinor} tone="base" /></div>
                                                </span>
                                        }
                                    },
                                }}
                                scroll={{ x: 700 }}
                            />
                            : <EmptyState image={NoResultsFound} heading={t("No products found!")} />
                }
                {totalPages > 1 && <InlineStack align="center" gap="400">
                    <Pagination
                        label={`${activePage}/ ${totalPages || 0}`}
                        hasPrevious={activePage != 1}
                        hasNext={activePage != totalPages}
                        onPrevious={() => onPrev()}
                        onNext={() => onNext()}
                    />
                </InlineStack>}
            </BlockStack>
        </Card>
    )
}
export default DI(NewProductImport)

const RenderVariants = ({ rowData, key, index, t }: variantProps) => {
    const [variantsRow, setvariantsRows] = useState([]);

    useEffect(() => {
        let temp: any = [];
        rowData?.additionalDataFromEditProd?.length > 0 &&
            rowData?.additionalDataFromEditProd?.forEach((data: any) => {
                temp?.push({
                    key: key + index,
                    variant_title: <Text as='p' variant='headingSm'>{data?.title}</Text>,
                    unique_id: <Text as='p'>{data?.id}</Text>
                })
            })
        setvariantsRows(temp)
    }, [])

    return <Table columns={variantsColumns(t)} dataSource={[...variantsRow]} size="middle" bordered pagination={false} />
}